import React from 'react';
import { renderCardIcon, docIcon } from '../common/IconLibrary';

const DocumentationCard = ({ title, description, onClick }) => (
  <div 
    className="card-glass"
    onClick={onClick}
  >
    <div className="flex items-center mb-4">
      <div className="w-12 h-12 flex items-center justify-center mr-4">
        {/* <FaBookOpen className="text-white text-2xl" /> */}
        <span className="absolute text-xs text-gray-300">
          {renderCardIcon(docIcon)}
        </span>
      </div>
      <h3 className="text-xl font-semibold text-gray-100">{title}</h3>
    </div>
    <div className="relative group">
      <p className="text-gray-300 mb-4 h-12 line-clamp-2 overflow-hidden">
        {description}
      </p>
      <div className="hint-glass">
        {description}
      </div>
    </div>
    {/* <div className="flex items-center justify-between text-gray-300 mt-4">
      <span className="text-sm">Click to view</span>
      <FaChevronRight className="text-gray-400" />
    </div> */}
  </div>
);

export default DocumentationCard;